import { ArrowRight, MapPin } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative grain overflow-hidden bg-white border-b-2 border-black"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 lg:py-36 relative">
        <div className="inline-flex items-center gap-2 border-2 border-black px-3 py-1 mb-8 animate-rise">
          <MapPin className="h-4 w-4 text-[#E60000]" strokeWidth={2.5} />
          <span className="font-heading font-bold uppercase text-xs tracking-widest">
            UK Based IT Support
          </span>
        </div>

        <h1
          data-testid="hero-heading"
          className="font-heading font-black uppercase tracking-tighter text-5xl md:text-7xl lg:text-[5.5rem] leading-[0.95] max-w-4xl animate-rise"
          style={{ animationDelay: "0.05s" }}
        >
          Solutions,
          <br />
          <span className="text-[#E60000]">Support</span> and
          <br />
          Success.
        </h1>

        <p
          className="mt-8 text-lg md:text-xl text-black/70 max-w-xl leading-relaxed animate-rise"
          style={{ animationDelay: "0.15s" }}
        >
          Friendly, expert IT and Microsoft 365 support for small businesses.
          From migrations to Wi-Fi, we keep your technology working so you can
          focus on running your business.
        </p>

        <div
          className="mt-10 flex flex-col sm:flex-row gap-4 animate-rise"
          style={{ animationDelay: "0.25s" }}
        >
          <a
            href="#contact"
            data-testid="hero-enquire-btn"
            className="group inline-flex items-center justify-center gap-2 bg-[#E60000] text-white font-heading font-bold uppercase tracking-wide px-8 py-4 border-2 border-black hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[6px_6px_0_0_#000] transition-all"
          >
            Get in touch
            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#services"
            data-testid="hero-services-btn"
            className="inline-flex items-center justify-center gap-2 bg-white text-black font-heading font-bold uppercase tracking-wide px-8 py-4 border-2 border-black hover:bg-black hover:text-white transition-colors"
          >
            View services
          </a>
        </div>
      </div>
    </section>
  );
};
